import { render } from "./ProductsInOrder.vue?vue&type=template&id=995c262a&scoped=true"
import script from "./ProductsInOrder.vue?vue&type=script&lang=js"
export * from "./ProductsInOrder.vue?vue&type=script&lang=js"

import "./ProductsInOrder.vue?vue&type=style&index=0&id=995c262a&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-995c262a"]])

export default __exports__